<script setup lang="ts">
import { PropType } from 'vue';
import GetListStatusResponseItemModel from '../models/GetListStatusResponseItemModel';
import { InformationCircleIcon } from 'tir-style-system/icons/outline';
import { TirPmTooltipElement } from 'tir-pm-tooltip-element';

/**Параметры */
const props = defineProps({
  /**Опции статуса */
  options: { type: Object as PropType<GetListStatusResponseItemModel>, required: true },
});
/**События */
const emit = defineEmits<{
  /**Событие выбора статуса */
  selectStatus: [];
}>();

/**Выбрать статус */
const selectStatus = () => {
  emit('selectStatus');
};
</script>

<template>
  <div class="status-parameter__block" @click="selectStatus">
    <div class="status-parameter" :style="{ borderColor: options.Color }">
      <div class="status-parameter__bg" :style="{ backgroundColor: options.Color }" />
      <div class="status-parameter__indicator" :style="{ backgroundColor: options.Color }" />
      <span class="status-parameter__text" :style="{ color: options.Color }">{{
        options.Name
      }}</span>
    </div>
    <TirPmTooltipElement v-if="options.Description">
      <InformationCircleIcon class="status-parameter__icon" />
      <template #content>
        <div class="status-parameter__description">
          {{ options.Description }}
        </div>
      </template>
    </TirPmTooltipElement>
  </div>
</template>

<style scoped lang="scss">
.status-parameter {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  overflow: hidden;
  padding: 0.125rem 0.5rem;
  font-size: 0.688rem;
  border-style: solid;
  border-width: 0.063rem;
  border-radius: 0.25rem;

  &__description {
    display: flex;
    justify-content: center;
    overflow-wrap: break-word;
  }
  &__block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.875rem;
    padding: 0.75rem;
    cursor: pointer;
    &:hover {
      background-color: var(--neutral-translucent-5);
    }
  }
  &__icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__indicator {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 62.4375rem;
  }

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0.1;
  }
  &__text {
    position: relative;
    z-index: 1;
    line-height: 1rem;
    font-size: 0.75rem;
    font-weight: 500;
  }
}
</style>
